<template>
    <div class="header-search-form" :class="{'p-0' : $ceres.isShopBuilder}">
        <div class="position-relative">
            <div class="d-flex">
                <input type="search"
                       class="header-search-input search-input form-control"
                       :placeholder="$translate('OD3dprimaV2::Template.itemSearchSearchTerm')"
                       ref="searchInput"
                       v-model="searchString"
                       @input="onValueChanged($event.target.value)"
                       @keyup.enter="search()"
                       @focus="isSearchFocused = true"
                       @blur="onBlurSearchField($event)"
                       :aria-label="$translate('Ceres::Template.headerSearchTerm')">
                <slot name="search-button">
                    <button class="search-submit header-search-btn" type="submit" @click="search()" aria-label="Suche" :aria-label="$translate('Ceres::Template.headerSearch')">
                      <icon class="fa-fw" icon="search" :loading="autocompleteIsLoading"></icon>
                    </button>
                </slot>
            </div>
            <template v-if="isSearchFocused">
                <div v-show="hasInitialInput || $ceres.isShopBuilder">
                    <slot name="autocomplete-suggestions">
                        <div class="autocomplete-suggestions">
                            <div class="headline__24 headline__24--white bg-primary autocomplete-suggestions__title">
                                {{ $translate('OD3dprimaV2::Template.searchResultTitle') }}
                            </div>
                            <div class="autocomplete-suggestions__scroll">
                                <item-search-result type="item"></item-search-result>
                                <item-search-result type="category"></item-search-result>
                            </div>
                        </div>
                    </slot>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import UrlService from "ceres/app/services/UrlService";
    import {isNullOrUndefined, defaultValue} from "ceres/app/helper/utils";
    import {pathnameEquals} from "ceres/app/helper/url";
    import {mapState} from 'vuex';
    import {debounce} from 'ceres/app/helper/debounce';

    export default {
        name: "item-search",
        props: {
            showItemImages:
                {
                    type: Boolean
                },
            forwardToSingleItem:
                {
                    type: Boolean,
                    default: App.config.search.forwardToSingleItem
                },
            timeout:
                {
                    type: Number,
                    default: 200
                },
          searchMinLength:
              {
                type: Number,
                default: 2
              }
        },

        data()
        {
            return {
                isSearchFocused: App.isShopBuilder,
                onValueChanged: null,
                searchString: "",
                hasInitialInput: false
            };
        },

        computed:
            {
                hasAutocompleteResults()
                {
                    const item       = this.autocompleteResult.item;
                    const category   = this.autocompleteResult.category;
                    const suggestion = this.autocompleteResult.suggestion;

                    return App.isShopBuilder || (item && item.length) || (category && category.length) || (suggestion && suggestion.length);
                },

                isShopBuilder()
                {
                    return App.isShopBuilder;
                },

                ...mapState({
                    autocompleteResult: state => state.itemSearch.autocompleteResult,
                    moduleSearchString: state => state.itemList.searchString,
                    autocompleteIsLoading: state => state.itemSearch.autocompleteIsLoading

                })
            },

        mounted()
        {
            this.onValueChanged = debounce(searchString =>
            {
                this.autocomplete(searchString);
            }, defaultValue(this.timeout, 200));

            this.$nextTick(() =>
            {
                const urlParams = UrlService.getUrlParams(document.location.search);

                this.$store.commit("setItemListSearchString", urlParams.query);

                this.$refs.searchInput.value = !isNullOrUndefined(urlParams.query) ? urlParams.query : "";
            });
        },

        methods:
            {
                search()
                {
                    if (this.$refs.searchInput.value.length)
                    {
                        if (pathnameEquals(App.urls.search))
                        {
                            this.$store.dispatch("searchItems", this.$refs.searchInput.value);
                        }
                        else
                        {
                            let url = App.urls.search;

                            //shop url is missing /se on lang se
                            if(App.language === 'se' && url.indexOf('/se/')) {
                                url = '/se'+App.urls.search;
                            }

                            window.open(`${url}?query=${ this.searchString }`, "_self", false);
                        }
                    }
                },

                autocomplete(searchString)
                {
                    if (searchString.length >= this.searchMinLength)
                    {
                        this.$store.dispatch("loadItemSearchAutocomplete", searchString);
                    }
                    else
                    {
                        this.$store.commit("setAutocompleteResult", { item: [], category: [], suggestion: [] });

                        // hide the autocomplete box
                        this.hasInitialInput = false;
                    }
                },

                // hide search, if targetElement of the blur event is not a child of components' root element
                onBlurSearchField(event)
                {
                    const target = event.relatedTarget;

                    if (isNullOrUndefined(target) || !isNullOrUndefined(target) && !this.$el.contains(target))
                    {
                        this.isSearchFocused = false;
                    }
                }
            },

        watch:
            {
                // set the current search string, after clicking on a suggestion
                moduleSearchString(newVal)
                {
                    if (newVal && newVal.length)
                    {
                        this.searchString = newVal;
                    }
                },

                autocompleteIsLoading(newVal, oldVal) {
                  // when client was loading and has stopped now, the autocomplete box should be shown
                  if (oldVal && !newVal) {
                    this.hasInitialInput = true;
                  }
                }
            }
    }
</script>
